<script setup>
defineProps({
  error: String
})
</script>

<template>
    <p class="p-error text-xs font-medium my-1 mx-0" style="line-height: 1.3 !important" v-if="error">{{ error || '&nbsp;' }}</p>
</template>